import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BrandCollaboration = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to new Partnership page
    navigate('/partnership', { replace: true });
  }, [navigate]);
  
  return null; // Redirecting...
};

export default BrandCollaboration;
